<script lang="ts">
    export let formNumber: number = 0
</script>

<form id="page-form" style="margin-top: 50px" on:submit>
    <div style="display: flex; width:100%;">
        <div class="radio-rating-container">
            <input id="practice-rating-1" type="radio" name="practice-rating" value="1" required>
            <label for="practice-rating-1">1</label>
        </div>
        <div class="radio-rating-container">
            <input id="practice-rating-2" type="radio" name="practice-rating" value="2">
            <label for="practice-rating-2">2</label>
        </div>
        <div class="radio-rating-container">
            <input id="practice-rating-3" type="radio" name="practice-rating" value="3">
            <label for="practice-rating-3">3</label>
        </div>
        <div class="radio-rating-container">
            <input id="practice-rating-4" type="radio" name="practice-rating" value="4">
            <label for="practice-rating-4">4</label>
        </div>
        <div class="radio-rating-container">
            <input id="practice-rating-5" type="radio" name="practice-rating" value="5">
            <label for="practice-rating-5">5</label>
        </div>
        <div class="radio-rating-container">
            <input id="practice-rating-6" type="radio" name="practice-rating" value="6">
            <label for="practice-rating-6">6</label>
        </div>
        <div class="radio-rating-container">
            <input id="practice-rating-7" type="radio" name="practice-rating" value="7">
            <label for="practice-rating-7">7</label>
        </div>
    </div>
    <div style="display:flex;align-items:center;margin-top:25px;">
        <svg style="width:calc(100% - 10px);height:5px">
            <rect fill="currentColor" width="100%" height="5" />
        </svg>
        <svg style="width:10px;height:20px" viewBox="0 0 5 10">
            <polygon fill="currentColor" points="0,0 0,10 5,5" />
        </svg>
    </div>
    <div style="display:flex;">
        <div style="max-width:33%;">
            {#if formNumber === 0}
                <p>Très difficile de se faire une image mentale</p>
            {/if}
        </div>
        <div style="flex:1;"></div>
        <div style="max-width:33%;text-align:right;">
            {#if formNumber === 0}
                <p>Très facile de se créer une image mentale</p>
            {/if}
        </div>
    </div>
    <div style="display: flex; justify-content:center;margin-top:15px;">
        <input id="practice-rating-unknown" type="radio" name="practice-rating" value="unknown">
        <label for="practice-rating-unknown">Je ne connais pas ce mot</label>
    </div>
</form>

<style>
    .radio-rating-container {
        display:flex;
        flex:1;
        justify-content:center;
    }

    .radio-rating-container label {
        margin-left: 8px;
    }
</style>